import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search"
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from "@mui/material/IconButton";
import { asTitle } from "./Utils";
import { useTranslation } from "react-i18next";

export type FilterProps = {
	onChange: (value: string) => void;
}

const Filter: React.FC<FilterProps> = (props: FilterProps) => {

	const { t } = useTranslation();

	// TODO: convert to uncontrolled component.
	const [value, setValue] = useState("");

	useEffect(() => {
		props.onChange(value);
	}, [value]);

	return <Input
		id="filter"
		type="text"
		placeholder={asTitle(t("filter"))}
		sx={{ float: "right" }}
		value={value}
		onChange={event => setValue(event.target.value)}
		endAdornment={
			<InputAdornment position="end">
				{value === ""
					? <SearchIcon sx={{ marginLeft: 1, marginRight: -0.5}} />
					: <IconButton edge="end" onClick={() => setValue("")}>
						<ClearIcon />
					</IconButton>
				}
			</InputAdornment>
		}
	/>
}

export default Filter;